import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';

export const StyledSelect = styled(Select)({
  height: '44px',
  width: '100%',
  '& .MuiSelect-icon': {
    top: '7px',
  },
  border: '1px solid #E4E9F1',
  boxSizing: 'border-box',
  backgroundColor: 'none',
  '& > .MuiSelect-select:focus': {
    backgroundColor: 'inherit',
  },
});
